import { render, staticRenderFns } from "./VoteHistoryModal.vue?vue&type=template&id=62d9a06f&scoped=true"
import script from "./VoteHistoryModal.vue?vue&type=script&lang=js"
export * from "./VoteHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./VoteHistoryModal.vue?vue&type=style&index=0&id=62d9a06f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d9a06f",
  null
  
)

export default component.exports